
import { call, put, takeEvery } from "redux-saga/effects";
import { monThiApi } from "../../../api/tct/monThiApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IMonThiAddLopTinChiRequest } from "../../../model/request/tct/IMonThiAddLopTinChiRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IMonThi } from "../../../model/respone/tct/IMonThi";
import { eMonThiActionIds, IMonThiActionTypeBase, IMonThiActionTypes } from "../../action-types/tct/IMonThiActions";
import { rootActions } from "../../actions/rootActions";
import { IDongBoHinhThucThiRequest } from "../../../model/request/tct/IDongBoHinhThucThiRequest";
const mainAction = rootActions.toChucThi.monThi;
export function* monThiSaga(): any {
    yield takeEvery(eMonThiActionIds.LOAD_START, loadWorker)
    yield takeEvery(eMonThiActionIds.SAVE_START, saveWorker)
    yield takeEvery(eMonThiActionIds.ADD_LOP_TIN_CHI_START, addLopTinChiWorker)
    yield takeEvery(eMonThiActionIds.DELETE_START, deleteWorker)
    yield takeEvery(eMonThiActionIds.UPDATES_START, updateWorker)
    yield takeEvery(eMonThiActionIds.ADD_MON_THI_START, addMonThiWorker)
    yield takeEvery(eMonThiActionIds.SYS_HINH_THUC_THI_START, sysHinhThucThiWorker)
}

function* loadWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<undefined>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(monThiApi.SelectByDot, dotThiId)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.LOAD_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}
function* updateWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<IMonThi[]>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(monThiApi.Updates, payload.data)
    if (res.is_success) {
        yield put(mainAction.UPDATES_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.UPDATES_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}
function* addLopTinChiWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<IMonThiAddLopTinChiRequest>
    const request = payload.data;
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(monThiApi.AddLopTinChi, request)
    if (res.is_success) {
        yield put(mainAction.ADD_LOP_TIN_CHI_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.ADD_LOP_TIN_CHI_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* saveWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<IMonThi>
    const dotThiId = payload.dotThiId;
    const monThi = payload.data as IMonThi
    let res: IBaseRespone;
    if (monThi.id_dot_thi_mon > 0) {
        res = yield call(monThiApi.Update, monThi)
    } else {
        res = yield call(monThiApi.Insert, monThi)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.SAVE_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* deleteWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<IIdsRequest>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(monThiApi.Delete, payload.data)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.DELETE_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* addMonThiWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<IMonThi[]>
    const dotThiId = payload.dotThiId;
    const monThis = payload.data;
    const res: IBaseRespone = yield call(monThiApi.AddMonThi, monThis)
    if (res.is_success) {
        yield put(mainAction.ADD_MON_THI_SUCCESS({
            data: res.data,
            dotThiId
        }))
    }
}

function* sysHinhThucThiWorker(action: IMonThiActionTypes): any {
    const payload = action.payload as IMonThiActionTypeBase<IDongBoHinhThucThiRequest>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(monThiApi.DongBoHinhThucThi, payload.data)
    if (res.is_success) {
        yield put(mainAction.SYS_HINH_THUC_THI_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.SYS_HINH_THUC_THI_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}